import { useEffect, useRef, useState } from 'react';

/**
 * The rendered width of an element, kept current as it resizes.
 *
 * For drawing in real pixels: an SVG stretched with `preserveAspectRatio="none"`
 * squashes rounded bar ends and thickens lines on wide screens, so the charts
 * measure their box and lay themselves out to it instead.
 */
export function useElementWidth<T extends HTMLElement>() {
  const ref = useRef<T>(null);
  const [width, setWidth] = useState(0);

  useEffect(() => {
    const element = ref.current;
    if (!element) return;

    setWidth(element.clientWidth);
    const observer = new ResizeObserver(([entry]) => setWidth(entry.contentRect.width));
    observer.observe(element);
    return () => observer.disconnect();
  }, []);

  return { ref, width };
}
